import './GeoWaitingResult.css';

interface Props {
  /** Current round number, shown as context while waiting. */
  roundNumber?: number;
  /** Total rounds in the game. */
  totalRounds?: number;
}

/**
 * Themed placeholder shown after the geo round timer reaches zero and before
 * the `geo-result` SSE event arrives. It uses the same dark geo theme as the
 * play/result screens. The parent is responsible for unmounting this screen as
 * soon as the result arrives.
 */
const GeoWaitingResult: React.FC<Props> = ({ roundNumber, totalRounds }) => {
  return (
    <div className="geo-waiting" role="status" aria-live="polite">
      <div className="geo-waiting__content">
        <div className="geo-waiting__globe">
          <span className="geo-waiting__pin">📍</span>
          <span className="geo-waiting__ring" />
          <span className="geo-waiting__ring geo-waiting__ring--delay" />
        </div>

        <h2 className="geo-waiting__title">Calculating results…</h2>
        <p className="geo-waiting__subtitle">
          {roundNumber && totalRounds
            ? `Scoring round ${roundNumber} of ${totalRounds}`
            : 'Waiting for the game result'}
        </p>

        <div className="geo-waiting__dots">
          <span className="geo-waiting__dot" />
          <span className="geo-waiting__dot" />
          <span className="geo-waiting__dot" />
        </div>
      </div>
    </div>
  );
};

export default GeoWaitingResult;
